// 移动端适配工具
const MobileAdapter = {
  // 初始化移动端适配
  init() {
    this.detectMobileDevice();
    this.addViewportMeta();
    this.addMobileClasses();
    this.listenForOrientationChanges();
  },
  
  // 检测移动设备
  detectMobileDevice() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    document.documentElement.classList.toggle('mobile-device', isMobile);
    return isMobile;
  },
  
  // 添加视口元标签
  addViewportMeta() {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      document.head.appendChild(viewportMeta);
    }
    
    viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=5.0';
  },
  
  // 添加移动设备类
  addMobileClasses() {
    window.addEventListener('resize', () => {
      const isMobile = window.innerWidth <= 768;
      document.documentElement.classList.toggle('mobile-view', isMobile);
      
      // 根据屏幕尺寸添加特定类
      const isSmallMobile = window.innerWidth <= 375;
      document.documentElement.classList.toggle('small-mobile', isSmallMobile);
      
      const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;
      document.documentElement.classList.toggle('tablet-view', isTablet);
    });
    
    // 初始触发一次
    window.dispatchEvent(new Event('resize'));
  },
  
  // 监听屏幕方向变化
  listenForOrientationChanges() {
    window.addEventListener('orientationchange', () => {
      // 方向变化后重新应用样式
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 200);
    });
  }
};

export default MobileAdapter;
